import React from "react";
import PropTypes from "prop-types";
import { META, ORDEN_ESTADOS } from "./estados";

const EstadoRutas = ({ cnt, total, worst }) => {
  const dist = ORDEN_ESTADOS.filter((k) => cnt[k] > 0).map((k) => ({
    k,
    label: META[k].label,
    dot: META[k].dot,
    n: cnt[k],
    pct: total ? Math.round((cnt[k] / total) * 100) : 0,
  }));
  const aria = `Distribución de rutas: ${dist.map((d) => `${d.label} ${d.n}`).join(", ")}`;

  return (
    <section className="ms-card ms-section">
      <h2>Estado de las rutas</h2>
      <div className="ms-dist-bar" role="img" aria-label={aria}>
        {dist.map((d) => (
          <div key={d.k} style={{ flex: `${d.n} 1 0`, background: d.dot }}></div>
        ))}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {dist.map((d) => (
          <div className="ms-dist-row" key={d.k}>
            <span>
              <span className="ms-dot" style={{ width: 10, height: 10, background: d.dot }}></span>
              {d.label}
            </span>
            <span>
              {d.n} <span style={{ fontWeight: 500, color: "#5c5c64" }}>· {d.pct}%</span>
            </span>
          </div>
        ))}
      </div>
      <div className="ms-worst">
        <span className="ms-eyebrow">Mayor demora</span>
        {worst ? (
          <>
            <span style={{ fontSize: 14, fontWeight: 600 }}>
              {worst.name} ({worst.cliente})
            </span>
            <span style={{ fontSize: 13, color: "#5c5c64" }}>
              Sin actualizar desde las {worst.lastTime} ({worst.ago})
            </span>
          </>
        ) : (
          <span style={{ fontSize: 14, fontWeight: 600 }}>Ninguna ruta en curso con demora</span>
        )}
      </div>
    </section>
  );
};

EstadoRutas.propTypes = {
  cnt: PropTypes.object,
  total: PropTypes.number,
  worst: PropTypes.object,
};

export default EstadoRutas;
